module.exports = __webpack_public_path__ + "static/img/emptyData.235b5892.png";